module.exports = __webpack_public_path__ + "img/reports.a3bb2525.svg";